<template>
    <div class="keydata-ps-basic-message" >
        <div class="keydata-ps-basic-btns" v-if="changeFlag">
            <el-button class="bigData-btn-change-Apply" type="primary" @click="onChangeApply">变更申请</el-button>
        </div>
        <el-form ref="form" :class="{'keydata-ps-basic-form': changeFlag}" :model="form" label-width="155px" :rules="rules" size="mini" style="font-size: 14px">
            <div v-for="(formConfig, formIndex) in formListConfig" :key="formIndex">
                <div class="form-title">{{ formConfig.title }}</div>
                <el-row class="input_content">
                    <el-col :span="6" v-for="(item, index) in formConfig.items" :key="item.prop+index">
                        <el-form-item :prop="item.prop"
                            v-if="item.type === 'span'"
                            :label="item.label"
                            class="relative-form-item">
                            <span>{{ form[item.prop] }}</span>

                        </el-form-item>
                        <el-form-item
                            :prop="item.prop"
                            v-if="item.type === 'input' && !item.hiddenInBase"
                            :label="item.label"
                            class="relative-form-item">
                               <div slot="label" class="form-item-label">
                                    {{ item.label }}
                                    <el-tooltip v-if="item.tooltip" class="item" effect="dark" placement="top">
                                        <div slot="content">
                                            <div>{{ item.tooltip }}</div>
                                        </div>
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </div>
                            <el-input
                                :disabled="item.disabled"
                                v-model.trim="form[item.prop]"
                                placeholder
                                v-if="!item.popover"></el-input>
                            <el-popover
                                popper-class="basic-msg-popover"
                                placement="bottom"
                                width="285"
                                trigger="click"
                                :content="item.popContent"
                                v-else>
                                <!-- 产权属性 = 【美的自建、安得自建】，可租面积不置灰 -->
                                <el-input
                                    :disabled="item.disabled"
                                    v-model.trim="form[item.prop]"
                                    placeholder
                                    slot="reference"
                                    class="popover-input"></el-input>
                                </el-popover>
                        </el-form-item>
                        <el-form-item
                            v-if="item.type === 'mSelect' && !item.hiddenInBase && !item.optionNum && item.prop === 'propertyType'"
                            :prop="item.prop"
                            :label="item.label"
                            :class="{ 'multiple-select-form-item': item.multiple }">
                            <MSelect2
                            v-if="item.options.length"
                            :disabledOptions="disabledPropertyTypeArr"
                            :value="form[item.prop]"
                            :flag="item.label"
                            :disabled="item.disabled"
                            :optionArr="item.options||[]"
                            :multiple="item.multiple"
                            :prop="item.prop"
                            :filterable="false"
                            @input="data => propsChange(data, item.prop, formIndex)"></MSelect2>
                            </el-form-item>
                        <el-form-item
                            v-if="item.type === 'mSelect' && !item.hiddenInBase && !item.optionNum && item.prop !== 'propertyType'"
                            :prop="item.prop"
                            :label="item.label"
                            :class="{ 'multiple-select-form-item': item.multiple }">
                            <MSelect
                            v-if="item.options.length"
                            :value="form[item.prop]"
                            :flag="item.label"
                            :disabled="item.disabled"
                            :optionArr="item.options||[]"
                            :multiple="item.multiple"
                            :prop="item.prop"
                            :filterable="false"
                            @input="data => propsChange(data, item.prop, formIndex)"></MSelect>
                            </el-form-item>
                        <el-form-item
                            v-if="item.type === 'mSelect' && !item.hiddenInBase && item.optionNum && item.optionNum !== 'SYS_SU_FIRE_INSPECTION'"
                            :prop="item.prop"
                            :label="item.label"
                            :class="{ 'multiple-select-form-item': item.multiple }">
                            <MSelect
                                :option-num="item.optionNum"
                                :value="form[item.prop]"
                                :flag="item.label"
                                :disabled="item.disabled"
                                :multiple="item.multiple"
                                :prop="item.prop"
                                :filterable="false"
                                @input="data => propsChange(data, item.prop, formIndex)"></MSelect>
                        </el-form-item>
                        <el-form-item
                            v-else-if="item.type === 'mSelect' && !item.hiddenInBase && item.optionNum && item.optionNum === 'SYS_SU_FIRE_INSPECTION'"
                            :prop="item.prop"
                            :label="item.label"
                            :class="{ 'multiple-select-form-item': item.multiple }">
                            <!-- <MSelect
                                :option-arr="fireOptArr"
                                :value="form[item.prop]"
                                :flag="item.label"
                                :disabled="item.disabled"
                                :multiple="item.multiple"
                                :prop="item.prop"
                                :filterable="false"
                                @input="data => propsChange(data, item.prop, formIndex)"></MSelect> -->
                            <el-select @input="data => propsChange(data, item.prop, formIndex)" :multiple="item.multiple" :disabled="item.disabled" v-model="form[item.prop]" placeholder="请选择">
                                <el-option
                                v-for="op in fireOptArr"
                                :key="op.value"
                                :label="op.label"
                                :value="op.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 产权属性等于安得租赁 -->
                        <el-form-item v-if="uploadList.includes(item.prop)" :label="item.label" :prop="item.prop">
                            <el-tooltip class="item" effect="dark" :disabled="form[item.prop]?false:true" :content="form[item.prop]" placement="top">
                                <el-input :disabled="item.disabled" v-model="form[item.prop]" placeholder="" class="upload-input-class" readonly>
                                    <div slot="suffix" class="">
                                        <el-button :disabled="item.disabled" class="upload-item-icon iconfont iconicon_export" type="text" @click="onUpload(item)"></el-button>
                                        <el-button :disabled="item.disabled" type="text" class="upload-item-download"  @click="onDownload(item)">下载</el-button>
                                    </div>
                                </el-input>
                            </el-tooltip>
                            

                        </el-form-item>
                        <el-form-item :label="item.label" :prop="item.prop" v-if="item.type === 'date'">
                            <el-date-picker
                                width="150px"
                                :disabled="item.disabled"
                                value-format="yyyy-MM-dd"
                                v-model="form[item.prop]"
                                type="date"></el-date-picker>
                        </el-form-item>
                        <el-form-item :label="item.label" :prop="item.prop" v-if="item.type === 'advance'">
                            <el-tooltip placement="top" :disabled="form[item.prop] === ''">
                                <div slot="content" v-text="form[item.prop]"></div>
                                <OtpAdvance
                                    :title="item.name"
                                    :disabled="item.disabled"
                                    :form-data="form"
                                    :prop="item.prop"
                                    :m-value="form[item.prop]"
                                    :params="item"
                                    @getAdvanceValue="getAdvanceValue"></OtpAdvance>
                            </el-tooltip>
                        </el-form-item>
                        <!-- weightedInput加权表单 -->
                        <el-form-item
                            :prop="item.prop"
                            v-if="item.type === 'weightedInput' && isFormItemFlag"
                            :label="item.label"
                            class="relative-form-item">
                                <div slot="label" class="form-item-label">
                                    {{ item.label }}
                                    <el-tooltip v-if="item.tooltip" class="item" effect="dark" placement="top">
                                        <div slot="content">
                                            <div>{{ item.tooltip }}</div>
                                        </div>
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </div>
                            <!-- 安得已租赁面积 置灰 -->
                            <el-input
                                :disabled="weightedDisabled"
                                v-model.trim="form[item.prop]"
                                placeholder></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>
        <UploadDialog ref="uploadDialog"></UploadDialog>
    </div>
</template>
<script>
import Decimal from 'decimal.js';
import { dictWithUrl } from '@/components/lots/api';
import { mapGetters } from 'vuex'
import { formListConfig } from './basicConfig.js'
import { rules, form, WH_STATUS, WH_AUDIT_STATUS } from './initData.js'
import { SRM_YES } from '../../../../../constant/constant.js'
import { savePhysicalBasicInfo,changeApply } from '../../../../../api/addPhysicalStorage.js'
import OtpAdvance from '../../../../../components/bulletFrame/otpAdvance/index.vue'
import MSelect from '../../../../../components/Select.vue'
import MSelect2 from '@/components/lots/otpSelect2';
import UploadDialog from './UploadDialog.vue'

export default {
    components: { OtpAdvance, MSelect,UploadDialog, MSelect2 },
    props: {
        whCode: {
            type: String,
            default() {
                return ''
            },
        },
        // 加权表单置灰
        weightedDisabled: {
            type: Boolean,
            default() {
                return false
            },
        },
        // 变更状态
        changeFlag: {
            type: Boolean,
            default() {
                return false
            },
        },
        // 是否特权修改
        isPrivilege: {
            type: Boolean,
            default() {
                return false
            },
        },
    },
    data() {
        return {
            // uploadList:['warehouseFileUrl','platformWarehouseFileUrl','warehouseInfoFileUrl','warehouseOtherFileUrl'],
            uploadList:['warehouseFileUrl','warehouseInfoFileUrl','warehouseOtherFileUrl'],
            fireOptArr: [], //消防验收字典下拉
            formListConfig,
            form: JSON.parse(JSON.stringify(form)),
            isFormItemFlag: false, // 加权表单项显示控制
            changeApplyLoading: false, // 物理仓变更loading
            mipNum: this.$store.state.mipNum, // 控制是否自动跳转MIP审批
            disabledPropertyTypeArr: ['3', '4', '6', '7', '8'], //置灰产权属性字典
        }
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode', 'btnPermissions']),
        // 按钮权限-仓库详情展示
        isUserRights() {
            return this.btnPermissions.includes('04000301')
        },
        // 当前登录账号
        userCode() {
            return this.$store.state.user.userCode
        },
        // 基本信息表单规则
        rules() {
            const raValidator = (rule, value, callback) => {
                const reg = /^\d{1,8}(\.\d{1,2})?$/
                if (['', null, undefined].includes(value)) {
                    callback()
                } else if (reg.test(value)) {
                    if (Number(value) > 0 && (Number(value) < Number(this.form.whSquare) - Number(this.form.usableArea))) {
                        callback()
                    } else {
                        callback(new Error('限制大于0，小于(仓库建筑面积-安得已租面积)'))
                    }
                } else {
                    callback(new Error('请输入8位正数，可保留2位小数'))
                }
            }
            return {
                ...rules,
                rentableArea: [
                    { required: true, message: '请输入剩余可租面积', trigger: ['blur', 'change'] },
                    { validator: raValidator, trigger: ['blur', 'change'] },
                ],
                warehouseFileUrl: [{ required: !this.isPrivilege, message: '请上传仓库评审方案', trigger: ['blur', 'change'] }],
                warehouseInfoFileUrl: [{ required: !this.isPrivilege, message: '请上传仓库寻源信息登记表', trigger: ['blur', 'change'] }],
            }
        },
    },
    created() {
        //字典 产权属性： SYS_PROPERTY_RIGHTS 
        dictWithUrl('SYS_SU_FIRE_INSPECTION,SYS_PROPERTY_RIGHTS').then(res => {
            if (res && +res.code === 0) {
                //消防验收字典要按规定顺序进行排序
                // 按这个字典编码进行排序 ['4','8','7','6','1','11','12','13','14','2','3']
                const sortArr = ['4','8','7','6','1','11','12','13','14','2','3']
                //查找出不在编码排序内的选项
                const newOpts = Object.keys(res.data['SYS_SU_FIRE_INSPECTION']).filter(v => sortArr.indexOf(v) === -1)
                //将固定顺序的选项（已启用）与不在顺序内的选项合并，后者选项排后面
                const fireOpts = [...(sortArr.filter(v => res.data['SYS_SU_FIRE_INSPECTION'][v])),...newOpts]

                this.fireOptArr = fireOpts.map(v => {
                    return {
                        label: res.data['SYS_SU_FIRE_INSPECTION'][v],
                        value: v
                    }
                })

                for (const formItem of this.formListConfig) {
                    if (formItem.title === '仓库资质') {

                        // 产权属性字典按这个字典编码进行排序  ['1','2','9'] 
                        const propertyTypeArr = ['1','2','9']
                        //查找出不在编码排序内的选项
                        const propertyTypeOpts = Object.keys(res.data['SYS_PROPERTY_RIGHTS']).filter(v => propertyTypeArr.indexOf(v) === -1 && this.disabledPropertyTypeArr.indexOf(v) === -1)
                        //将固定顺序的选项（已启用）与不在顺序内的选项合并，后者选项排后面
                        const newPropertyTypeOpts = [...(propertyTypeArr.filter(v => res.data['SYS_PROPERTY_RIGHTS'][v])),...propertyTypeOpts, ...this.disabledPropertyTypeArr]

                        let propertyTypeList = newPropertyTypeOpts.map(v => {
                            return {
                                label: res.data['SYS_PROPERTY_RIGHTS'][v],
                                value: v,
                            }
                        })
                        for (const item of formItem.items) {
                            if( item.prop === 'propertyType'){
                                item.options = propertyTypeList
                                break;
                            }
                        }
                        
                    }
                    
                }
                
            }
        });
    },
    methods: {
        onUpload(row) {
            const {label}=row
            this.$refs.uploadDialog.show(label,row,this.form)
        },
        onDownload(row){
            const {prop} = row
            if(prop === 'warehouseFileUrl'){
                this.dowLoadFile('仓库评审方案');
                // this.$message.warning('暂无下载功能')
            }
            // else if(prop === 'platformWarehouseFileUrl'){
            //     this.dowLoadFile('平台仓库方案评审');
            //     // this.$message.warning('暂无下载功能')
            // }
            else if(prop === 'warehouseInfoFileUrl'){
                this.dowLoadFile('仓库寻源信息登记表');
                // this.$message.warning('暂无下载功能')
            }
            else if(prop === 'warehouseOtherFileUrl'){
                this.dowLoadFile('其他附件（可打包）');
                // this.$message.warning('暂无下载功能')
            }

        },
        dowLoadFile(name){
           const { leaseFileList } = this.form
           if(!leaseFileList){
            this.$message.warning('暂无下载文件')
            return
           }
           if(Array.isArray(leaseFileList) && leaseFileList.length === 0){
               this.$message.warning('暂无下载文件')
               return
           }
            for (const item of leaseFileList) {
                if(item.qualificationName === name){
                    const fileUrl = item.fileUrl
                    if (!fileUrl) {
                        this.$message.warning('下载链接有问题')
                        return
                    }
                    const a = document.createElement('a')
                    a.style.display = 'none'
                    a.download = item.fileName
                    a.href = fileUrl
                    a.click()
                    break
                }
            }
        },
        propsChange(value, prop, formIndex) {
            const data = {}
            data[prop] = value
            Object.assign(this.form, data)
            this.setVisible(value, prop, formIndex)
        },
        setVisible(value, prop, formIndex) {
            if (prop === 'factoryFlag') {
                // const fIndex = formListConfig[formIndex].items.findIndex(item => item.prop === 'factorySign')
                // if (+value === +SRM_YES) {
                //     this.formListConfig[formIndex].items[fIndex].hiddenInBase = false
                // } else {
                //     this.formListConfig[formIndex].items[fIndex].hiddenInBase = true
                //     this.form.factorySign = ''
                // }
            } else if (prop === 'poweredSystemFlag') {
                // const fIndex = formListConfig[formIndex].items.findIndex(item => item.prop === 'specificPower')
                // if (+value === +SRM_YES) {
                //     this.formListConfig[formIndex].items[fIndex].hiddenInBase = false
                // } else {
                //     this.formListConfig[formIndex].items[fIndex].hiddenInBase = true
                //     this.form.specificPower = ''
                // }
            }
        },
        getAdvanceValue(data) {
            if (data.ebplCode) {
                this.form.cityCode = data.ebplCode
                this.form.cityName = data.ebplNameCn
            } else if (data.eblcCode) {
                Object.keys(data).forEach(el => {
                    this.form[el] = data[el]
                })
                this.form.addressCode = data.eblcCode
                this.form.whAddress = data.eblcDetailAddress
            } else if (data.companyCode) {
                this.form.companyName = data.companyNameCn
            }
            this.form = { ...this.form, ...data,whCode:this.whCode }
        },
        // 详情-基本信息赋值
        setFormData(data) {
            this.$refs.form.resetFields()
            const originalForm=JSON.parse(JSON.stringify(form))
            this.form = {...originalForm,...data,whCode:this.whCode}
            //产权属性等于租赁
            if(data.propertyType === '2' && Array.isArray(data.leaseFileList)) { 
                for (const item of data.leaseFileList) {
                    if(item.qualificationName === '仓库评审方案'){
                        this.$set(this.form,'warehouseFileUrl',item.fileName) 
                    }
                    // else if(item.qualificationName === '平台仓库方案评审'){
                    //     this.$set(this.form,'platformWarehouseFileUrl',item.fileName) 
                    // }
                    else if(item.qualificationName === '仓库寻源信息登记表'){
                        this.$set(this.form,'warehouseInfoFileUrl',item.fileName) 
                    }
                    else if(item.qualificationName === '其他附件（可打包）'){
                        this.$set(this.form,'warehouseOtherFileUrl',item.fileName) 
                    }
                }
            }
            // 需要额外初始化存在 hiddenInBase 属性的字段
            this.setVisible(this.form.factoryFlag, 'factoryFlag', 3)
            this.setVisible(this.form.poweredSystemFlag, 'poweredSystemFlag', 2)
            // 当前登录账号是该仓的创建账号，或有仓库详情展示的按钮权限
            this.isFormItemFlag = this.userCode === this.form.createUserCode || this.isUserRights
        },
        // 新增-基本信息初始化
        initFormData() {
            this.$refs.form.resetFields()
            this.isFormItemFlag = true
            this.form = JSON.parse(JSON.stringify(form))
            this.clearDisabled()
        },
        // 设置全部置灰
        setAllDisabled() {
            this.formListConfig.forEach(formConfig => {
                formConfig.items.forEach(item => {
                    item.disabled = true
                })
            })
        },
        // 清除置灰项
        clearDisabled() {
            this.formListConfig.forEach(formConfig => {
                formConfig.items.forEach(item => {
                    if (['whStatus', 'approveStatus', 'contractStatus', 'eblcLongitude', 'eblcLatitude'].indexOf(item.prop) < 0) {
                        item.disabled = false
                    }
                })
            })
        },
        // 产权属性等于租赁，点击保存时触发
        saveValidate(){
            let validateFlag = '基本信息必填信息不能为空!'
            this.$refs['form'].validate(valid => {
                if (valid) {
                    validateFlag = valid
                }
            })
            const { whSquare, rentableArea, usableArea } = this.form
            if (+usableArea > +whSquare) {
                return validateFlag = '安得已租赁面积不能大于仓库建筑面积!'
            }
            
            // if (+this.form.rentableArea >= +this.form.whSquare) {
            //     return validateFlag = '可租面积不能大于或等于仓库建筑面积!'
            // }
            return validateFlag
        },
        saveData(){
            let params = null
            this.$refs['form'].validate(valid => {
                if (valid) {
                    const { whSquare, rentableArea, usableArea } = this.form
                    if (+usableArea > +whSquare) {
                        this.$message.warning('安得已租赁面积不能大于仓库建筑面积!')
                        return false
                    }
                    
                    // if (+this.form.rentableArea >= +this.form.whSquare) {
                    //     this.$message.warning('可租面积不能大于或等于仓库建筑面积!')
                    //     return false
                    // }
                    if (this.form.imagesList || this.form.qualificationInfos) {
                        delete this.form.imagesList
                        delete this.form.qualificationInfos
                    }
                    if (this.whCode) {
                        this.form.whCode = this.whCode
                    } else {
                        delete this.form.whCode
                    }
                    params={ ...this.form }
                   
                }
            })
            return params
        },
        // 保存
        saveFormData() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    const { whSquare, rentableArea, usableArea } = this.form
                    if (+usableArea > +whSquare) {
                        this.$message.warning('安得已租赁面积不能大于仓库建筑面积!')
                        return false
                    }
                    
                    // if (+this.form.rentableArea >= +this.form.whSquare) {
                    //     this.$message.warning('可租面积不能大于或等于仓库建筑面积!')
                    //     return false
                    // }
                    if (this.form.imagesList || this.form.qualificationInfos) {
                        delete this.form.imagesList
                        delete this.form.qualificationInfos
                    }
                    if (this.whCode) {
                        this.form.whCode = this.whCode
                    } else {
                        delete this.form.whCode
                    }
                    // 不是安得租赁仓库，则清空租赁文件
                    if(Array.isArray(this.form.leaseFileList) && this.form.propertyType !=='2'){
                        this.form.leaseFileList=[];
                        // this.form.platformWarehouseFileUrl= '';
                        this.form.warehouseFileUrl= '';
                        this.form.warehouseInfoFileUrl= '';
                        this.form.warehouseOtherFileUrl= '';
                    }
                    const params = { ...this.form }
                    savePhysicalBasicInfo(params).then(res => {
                        if (res && +res.code === 0) {
                            // this.whCode = res.data.whCode;
                            // this.whNameMip = res.data.data[0].whName;
                            // this.$message.success('基本信息保存成功');
                            // setTimeout(() => {
                            //     this.$router.push({
                            //         path: '/addPhysicalStorage',
                            //         name: 'addPhysicalStorage',
                            //         query: {
                            //             whCode: this.whCode
                            //         }
                            //     });
                            // }, FIVE_HUNDRED);

                            this.$message.success('基本信息保存成功')
                            this.$emit('save', res.data)
                        }
                    })
                }
            })
        },
        // 变更申请->检查表单->弹出人工决策弹窗
        onChangeApply(){
            this.$refs['form'].validate(valid => {
                if(valid) {
                    // 产权属性=安得租赁->弹出人工决策弹窗->变更申请保存
                    if(this.form.propertyType === "2"){
                        this.$emit('openArtificialDialog')
                    }
                    // 非安得租赁->变更申请保存
                    else{
                        this.onChangeApplySave()
                    }
                }
            })
        },
        // 变更申请保存
        onChangeApplySave(data = {}) {
            const params = { ...this.form , ...data}
            params.formParam = {
                // subject: '供应商注册-物理仓-变更申请',
                // formInstanceId: this.whCode,
                fdUrl: location.origin + location.pathname + `#/addPhysicalStorage?iflowWhType=whChange&whCode=` + this.whCode + '&iflow=' + this.mipNum
            }
             this.changeApplyLoading = true
            changeApply(params).then(res => {
                if (res && +res.code === 0) {
                    const query = {
                        processId: res.data.fdId,
                        formInstanceId: res.data.formId,
                        path: '/physicalStorage'
                    }
                    this.$router.push({
                        name: 'mipIframe',
                        query,
                    });
                }
            }).finally(()=>{
                this.changeApplyLoading = false
            })
        }
    },
    watch: {
        'form.propertyType': {
            handler(nVal) {
                if(nVal === '2'){//产权属性等于租赁
                    for (const item of this.formListConfig) {
                        if(item.title==='仓库资质'){
                            let items=item.items;
                            for (let i = 0; i < items.length; i++) {
                                const element = items[i];
                                if(element.prop==='propertyType'){
                                    let new1={
                                        label: '仓库评审方案',
                                        value: '',
                                        prop: 'warehouseFileUrl',
                                        type: 'input',
                                        disabled: false,
                                        hiddenInBase: true,
                                        popover: false,
                                    }
                                    // let new2={
                                    //     label: '平台仓库方案评审',
                                    //     value: '',
                                    //     prop: 'platformWarehouseFileUrl',
                                    //     type: 'input',
                                    //     disabled: false,
                                    //     hiddenInBase: true,
                                    //     popover: false,
                                    // }
                                    let new3={
                                        label: '仓库寻源信息登记表',
                                        value: '',
                                        prop: 'warehouseInfoFileUrl',
                                        type: 'input',
                                        disabled: false,
                                        hiddenInBase: true,
                                        popover: false,
                                    }
                                    let new4={
                                        label: '其他附件（可打包）',
                                        value: '',
                                        prop: 'warehouseOtherFileUrl',
                                        type: 'input',
                                        disabled: false,
                                        hiddenInBase: true,
                                        popover: false,
                                    }
                                    // item.items.splice(i+1,0,new1,new2,new3,new4)
                                    item.items.splice(i+1,0,new1,new3,new4)
                                    break
                                }
                            }
                        }
                    }
                }else{
                    for (const item of this.formListConfig) {
                        if(item.title==='仓库资质'){
                            let items=item.items;
                            for (const upImte of this.uploadList) {
                                for (let i = 0; i < items.length; i++) {
                                    const element = items[i];
                                    if( this.uploadList.includes(element.prop)){
                                        items.splice(i, 1);
                                        break
                                    }
                                }
                            }
                     
                        }
                    }
                }
                if (nVal !== '2' && nVal !== '5') {
                    this.$set(this.rules.fireUnitArea[0], 'required', false)
                } else {
                    this.$set(this.rules.fireUnitArea[0], 'required', true)
                }
                //当产权属性=美的自建，安得自建， 安得租赁，安得租赁（短租）,单价录入限制≥6，不能为0 ，不能为负数,否则按原逻辑
                this.$set(this.rules.unitPrice, '1', ['1', '2', '5', '9'].includes(nVal) ? {pattern: /^(?:[6-9](?:\.\d{1,2})?|[1-9]\d{1,4}(?:\.\d{1,2})?|[1-9]\d{5}(?:\.\d{1,2})?|999999(?:\.\d{1,2})?)$/, message: '请输入6-999999.99', trigger: ['blur', 'change']} : {pattern: /^([1-9]\d{1,5}|\d)(\.\d{1,2})?$/, message: '请输入0-999999.99', trigger: ['blur', 'change']})
            },
            immediate: true,
        },
        // 审批状态： 待审批 || 审批中 -> 全部置灰，保存按钮隐藏
        'form.approveStatus': {
            /**
             * SRM_PHY_WH_AUDIT_STATUS：物理仓审批状态
             * 【 1 == 草稿，2 == 审批中，3 == 审批通过，4 == 驳回，5 == 废弃 】
             */
            handler(nVal) {
                // 审批中、审批通过
                if ([WH_AUDIT_STATUS.APPROVALING, WH_AUDIT_STATUS.APPROVED].includes(nVal)) {
                    this.setAllDisabled()
                } else {
                    this.clearDisabled()
                }
            },
            immediate: true,
        },
        // 仓库状态：
        // 新增(0) => 创建人特权人可显示修改加权菜单
        // 合格(1) => 全部置灰，保存按钮隐藏，创建人特权人可显示加权菜单，仅特权人可以修改加权菜单;
        // 停用(2) => 创建人特权人可显示修改加权菜单
        'form.whStatus': {
            /**
             * SRM_PHY_WH_AUDIT_STATUS：物理仓仓库状态
             * 【 0 == 新增， 1 == 合格，2 == 停用，3 == 启用，4 == 驳回，5 == 废弃，6 == 待审批 】
             */
            handler(nVal) {
                if (nVal === WH_STATUS.ADD) {
                    // this.isUserDisabled = false;
                } else if (nVal === WH_STATUS.QUALIFIED) {
           
                    
                    this.setAllDisabled()
                    // 当前登录人是否创建人
                    const isCreateUser = this.userCode === this.form.createUserCode
                    // 仓库状态合格且审批通过后，创建人可以修改可用面积(m²)、单价(元/平方米)、联系人、联系电话 这四个字段，其他人使用特权修改
                    const saveBtnShow = isCreateUser && [WH_AUDIT_STATUS.APPROVED].includes(this.form.approveStatus)
                    this.$emit('setSaveBtnShow', saveBtnShow)
                } else {
                    this.clearDisabled()
                    // this.isUserDisabled = false;
                }
            },
            immediate: true,
        },
        'form.canopy': {
            handler(nVal) {
                this.$set(this.rules.canopyWidth[0], 'required', nVal !== '3')
                if(nVal === '3'){
                    this.$nextTick(() => {
                        this.$refs['form'].clearValidate()
                    })
                }
            },
            immediate: true,
        },
        changeFlag(nv,ov){
            // if(nv){
                
            // }
            // 【仓库状态  审批状态  合同状态， 是否特批 、经度、纬度 】不允许修改，其他允许修改
            let disabledList = [ 'whStatus', 'approveStatus', 'contractStatus', 'specialApproveFlag', 'eblcLatitude', 'eblcLongitude' ]
            for (const item of this.formListConfig) {
                let itemList = item.items
                if(Array.isArray(itemList)){
                    for (const child of itemList) {
                        if(disabledList.includes(child.prop)){
                            child.disabled = true
                        }else{
                             child.disabled = false
                        }
                    }
                }
                
            }
        }
    },
}
</script>
<style lang="less">
.keydata-ps-basic-message {
    position: relative;
    width: 90%;

    .el-input {
        position: relative;
    }
    
    .el-form-item__error{
        white-space: nowrap;
    }
    .keydata-ps-basic-btns{
      display: inline-block;
        margin:0 0 15px 0;
    }
    .form-item-label{
        display: inline-block;
    }
    .keydata-ps-basic-form{
        // .input_content{
        //         margin-left: 50px;
        // }
    }
   
    .upload-input-class {
        .upload-item-icon {
            position: absolute;
            top: -2px;
            right: 12px;
            width: 30px;
            height: 28px;
            font-size: 16px;
            color: #33c9cc;
            // cursor: pointer;
            z-index: 9;
        }
        .upload-item-download {
            position: absolute;
            top: 1px;
            right: -4px;
            width: 30px;
            height: 28px;
            font-size: 12px;
            color: #33c9cc;
            z-index: 9;
        }
        .el-input__inner {
                padding-right: 49px;
        }
    }
    
    .el-form-item {
        height: 28px;
    }

    .el-form-item.multiple-select-form-item {
        height: auto;
    }

    .el-select {
        width: 100%;
        min-width: 80px;
    }

    .el-input {
        width: 100%;
        min-width: 80px;
    }

    .el-date-editor.el-input {
        width: 100%;
        min-width: 80px;
    }

    .relative-form-item {
        position: relative;
    }

    .popover-input {
        position: absolute;
        top: 0;
        right: 0;
        border: 0;
    }
}
.basic-msg-popover{
    white-space: pre-wrap;
}
</style>
